import React, { useState } from "react";
import "./App.css";
import { Media } from "./Media";

function App() {
  const [selectedFile, setSelectedFile] = useState(null);

  return (
    <div className="media-container" style={{backgroundColor: "white"}}>
      {Media.map((media, index) => (
        <div className="media" key={index} onClick={() => setSelectedFile(media)}>
          {media.type === "image" ? (
            <img src={media.url} alt="" />
          ) : (
            <video src={media.url} muted />
          )}
        </div>
      ))}

      {/* Popup media */}
      {selectedFile && (
        <div className="popup-media" style={{display: selectedFile ? 'block' : 'none'}}>
          <span onClick={()=>{setSelectedFile(null)}}>&times;</span>
          {selectedFile.type === "video" ? (
            <video src={selectedFile.url} muted autoPlay controls />
          ) : (
            <img src={selectedFile.url} alt="" />
          )}
        </div>
      )}
    </div>
  );
}

export default App;
